var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Move element right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-forward",
    "data-name": "Icon ionic-md-arrow-round-forward",
    d: "M52.193,84.071,83.58,51.776a7.577,7.577,0,0,0,2.045-5.4v-.1a7.577,7.577,0,0,0-2.045-5.4L52.193,8.589a6.463,6.463,0,0,0-9.818,0,8.327,8.327,0,0,0,0,10.893L61.239,38.618H12.6c-3.864,0-6.977,3.446-6.977,7.712,0,4.338,3.114,7.712,6.955,7.712H61.216L42.352,73.177a8.327,8.327,0,0,0,0,10.893A6.488,6.488,0,0,0,52.193,84.071Z",
    transform: "translate(-5.625 -6.33)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRound);
export default __webpack_public_path__ + "static/media/arrowRightRound.f5a9f256d1760caa8004546b3cab5466.svg";
export { ForwardRef as ReactComponent };